import currentReqTypes from "./currentReq.types";

const INITIAL_STATE = {
  info: "",
  bits: "",

  loadLocation: "",

  isLoading: false,
  bitsIsLoading: false,
  loadLocationIsloading: false,
};

const currentReqReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case currentReqTypes.FETCH_CURRENTREQ_START:
      return {
        ...state,
        isLoading: true,
      };
    case currentReqTypes.FETCH_CURRENTREQ_SUCCESS:
      return {
        ...state,
        info: action.payload,
        isLoading: false,
      };

    //bits
    case currentReqTypes.FETCH_CURRENTREQBITS_START:
      return {
        ...state,
        bitsIsLoading: true,
      };

    case currentReqTypes.FETCH_CURRENTREQBITS_SUCCESS:
      return {
        ...state,
        bits: action.payload,
        bitsIsLoading: false,
      };

    // load location
    case currentReqTypes.FETCH_LOADLOACTION_START:
      return {
        ...state,
        loadLocationIsloading: true,
      };

    case currentReqTypes.FETCH_LOADLOCATION_SUCCESS:
      // alert("d");
      return {
        ...state,
        loadLocationIsloading: false,
        loadLocation: action.payload,
      };

    //CLEAR
    case currentReqTypes.CLEAR_CURRENTREQ:
      return {
        ...state,
        info: "",
        // bitsIsLoading: true,
      };

    default:
      return state;
  }
};

export default currentReqReducer;
